import React, { useState, useEffect, useContext } from 'react';
import client from '@js/modules/httpClient/index';
import { useForm } from 'react-hook-form';
import { useLocation } from 'react-router-dom';

import { usePath } from '@js/hooks/usePath';
import { Context } from '@js/routes';
import { InvestorRegistrationContainer } from '@js/components/common/investorRegistrations/InvestorRegistrationContainer';
import Toast from '@js/modules/toast/index';

type IdentificationTypeSelectionFormData = {
  type: string
};

export const CorporateIdentificationTypeSelection = () => {
  const { setIsLoading, isEdit, setIsEdit } = useContext(Context);
  const { register, handleSubmit, setValue } = useForm<IdentificationTypeSelectionFormData>({
    shouldUnregister: false
  });
  const { currentStep, pushNext } = usePath(isEdit);
  const location = useLocation();
  const [options, setOptions] = useState<{ category: string, name: string }[]>([
    { category: 'postcard', name: 'ハガキで本人確認' }
  ]);

  const onSubmit = (data: IdentificationTypeSelectionFormData) => {
    client.post('/api/v1/customer/corporate_registration/identification_type', {
      identity_verification_type: {
        category: data.type
      }
    })
      .then(pushNext)
      .catch((error) => {
        console.log(error);
      });
  };

  // 本来はcurrent_siteのshort_name（or 登録完了に要する日数のメッセージなど）をAPIから取得し、メッセージを出し分けるべき
  // ただ、急ぎの対応であるため、取り急ぎ、hostnameで判定するロジックにて対応する
  const trustHostnames = ['to-katsu.com', 'trust.demo.fincf.xyz', 'trust.dev.fincf.xyz', 'trust.stg.fincf.xyz'];
  const isSiteTrust = trustHostnames.includes(window.location.hostname);
  const checkPeriodMessage = isSiteTrust ? '即日〜3営業日程度で登録完了' : '即日〜1営業日程度で登録完了';

  useEffect(() => {
    setIsLoading(true);
    client.get('/api/v1/customer/corporate_registration/identification_type')
      .then(response => {
        const data = response.data;
        setOptions(data.types);
        setIsEdit(!data['registration_in_progress?']);
        //setValue('type',  data.default_type || data.types[0].category);
        setValue('type', 'postcard');
      }).finally(() => setIsLoading(false));
  }, []); // eslint-disable-line

  // URLパラメータからメッセージを取得してtoast表示
  useEffect(() => {
    const searchParams = new URLSearchParams(location.search);
    const fromParam = searchParams.get('from');

    let message = '';
    if (fromParam === 'basic_info') {
      message = '基本情報変更後は本人確認の完了が必要です。';
    } else if (fromParam === 'representative') {
      message = '担当者情報変更後は本人確認の完了が必要です。';
    }

    if (message) {
      new Toast().showMessage(message, 'error');
    }
  }, [location.search]);

  return (
    <InvestorRegistrationContainer formId={currentStep.name} isEdit={isEdit} >
      <div className="form-notes mt40">
        <div className="list-base font-bold">
          <div className="form-notes__index">オンライン本人確認（現在選択できません）</div>
          <ul className="list-short">
            <li className="list-short__item">本人確認書類  1種類</li>
            <li className="list-short__item">スマホで手続き完結</li>
            <li className="list-short__item">{checkPeriodMessage}</li>
          </ul>
        </div>

        <div className="list-base font-bold">
          <div className="form-notes__index">ハガキで本人確認</div>
          <ul className="list-short">
            <li className="list-short__item">本人確認書類  2種類</li>
            <li className="list-short__item">簡易書留ハガキを自宅で受け取り手続き</li>
            <li className="list-short__item">3〜5営業日程度で登録完了</li>
          </ul>
        </div>
      </div>
      <form onSubmit={handleSubmit(onSubmit)} className="form-wrap" id={currentStep.name}>
        {options.map(option =>
          <div key={option.category} className="form-input__wrap">
            <div className="form-radio">
              <div className="form-radio mr32">
                <label className="form-radio__label" htmlFor={`identity_verification_type_${option.category}`}>
                  <input
                    {...register('type')}
                    type="radio"
                    id={`identity_verification_type_${option.category}`}
                    className={'form-radio__input'}
                    value={option.category}
                    disabled={option.category === 'ekyc'}
                  />
                  <span className="form-radio__text">{option.name}</span>
                </label>
              </div>
            </div>
          </div>
        )}
      </form>
    </InvestorRegistrationContainer>
  );
};
